import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { tap } from 'rxjs';

import { Brand, CrisRequest } from 'app/model';
import { crisRequestService } from 'app/services/cris-request.service';
import { CrisListGrid } from 'features/cris/listing/cris-list-grid';

interface CrisDupeCheckProps {
    // manually inputed name
    name?: string;
    // selected brand
    brand?: Brand;
}

export const CrisDupeCheck: React.FunctionComponent<CrisDupeCheckProps> = ({ name, brand }) => {
    const [dupes, setDupes] = useState<CrisRequest[]>([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!name && !brand) {
            return;
        }
        const sub = crisRequestService
            .findDupes(name, brand)
            .pipe(
                tap((page) => {
                    setOpen(0 < page.data.length);
                }),
            )
            .subscribe((page) => setDupes(page.data));

        return () => sub.unsubscribe();
    }, [name, brand]);

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='xl'>
            <DialogTitle>Potential Duplicate Requests Identifier</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please avoid creating additional duplicates, instead work on one of the existing requests or cancel
                    them out before creating new ones.
                </DialogContentText>
                <CrisListGrid
                    openTarget='_blank'
                    rows={dupes}
                    sx={{ minHeight: '30em', minWidth: '40em' }}
                    density='compact'
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                                customer: false,
                                project: false,
                                taggerPriority: false,
                                priority: false,
                                estimatedDelivery: false,
                                businessImpact: false,
                                overdueImpact: false,
                            },
                        },
                        sorting: {
                            sortModel: [{ field: 'dateCreated', sort: 'desc' }],
                        },
                    }}
                />
            </DialogContent>
        </Dialog>
    );
};
